export const RIGHTS_DISCLAIMER =
  "RentDuo provides general rental information and AI-assisted guidance. RentDuo is not a law firm and does not provide legal advice. Laws vary by location. Contact a licensed attorney or official housing agency for advice about your specific situation.";

export const RIGHTS_DATA = {
  US: {
    tenant: {
      heading: "Tenant Rights",
      summary:
        "Renters should understand fair housing protections, lease terms, habitability basics, deposit rules, and local eviction process before problems happen.",
      links: [
        {
          title: "HUD Fair Housing",
          description:
            "Federal fair housing information covering protected classes, discrimination, complaints, and housing rights.",
          type: "Federal",
          url: "https://www.hud.gov/program_offices/fair_housing_equal_opp",
        },
        {
          title: "HUD Tenant Rights",
          description:
            "HUD resources for tenants, public housing residents, rental assistance, and housing questions.",
          type: "Federal",
          url: "https://www.hud.gov/topics/rental_assistance/tenantrights",
        },
      ],
    },
    landlord: {
      heading: "Landlord Rights",
      summary:
        "Housing providers should understand fair housing duties, lawful screening, maintenance obligations, lease enforcement, notice rules, and court process.",
      links: [
        {
          title: "HUD Fair Housing",
          description:
            "Federal fair housing guidance for housing providers and renters.",
          type: "Federal",
          url: "https://www.hud.gov/program_offices/fair_housing_equal_opp",
        },
      ],
    },
    property_manager: {
      heading: "Property Manager Responsibilities",
      summary:
        "Property managers should understand fair housing, maintenance response, licensing where required, communication records, and owner/tenant responsibilities.",
      links: [
        {
          title: "HUD Fair Housing",
          description:
            "Federal fair housing guidance relevant to property management and rental operations.",
          type: "Federal",
          url: "https://www.hud.gov/program_offices/fair_housing_equal_opp",
        },
      ],
    },
  },
  NJ: {
    tenant: {
      heading: "Tenant Rights",
      summary:
        "New Jersey tenants have rights around safe housing, court process for eviction, security deposits, notices, and fair housing protections.",
      links: [
        {
          title: "NJ Housing Help for Renters",
          description:
            "Official New Jersey housing help page for renters, rental assistance, eviction prevention, and legal help referrals.",
          type: "State",
          url: "https://www.nj.gov/basicneeds/housing/help-renter-tenant.shtml",
        },
        {
          title: "NJ DCA Landlord-Tenant Information",
          description:
            "Official New Jersey overview of tenant protections, housing standards, rental guidance, and landlord-tenant information.",
          type: "State",
          url: "https://www.nj.gov/dca/home/landlord-tenant.shtml",
        },
        {
          title: "NJ Courts Landlord-Tenant Self Help",
          description:
            "Official New Jersey court resource for landlord-tenant cases, hearings, filings, and court process.",
          type: "Court",
          url: "https://www.njcourts.gov/self-help/landlord-tenant",
        },
        {
          title: "NJ Eviction Guide",
          description:
            "Official step-by-step New Jersey eviction process guide.",
          type: "State",
          url: "https://evictionguide.dca.nj.gov/",
        },
      ],
    },
    landlord: {
      heading: "Landlord Rights",
      summary:
        "New Jersey landlords should understand court process, notices, habitability standards, deposit rules, inspections, and fair housing duties.",
      links: [
        {
          title: "NJ Courts Information for Landlords",
          description:
            "Landlord-focused official court guide explaining filing and handling landlord-tenant cases.",
          type: "Court PDF",
          url: "https://www.njcourts.gov/sites/default/files/forms/10289_info_landlords.pdf",
        },
        {
          title: "NJ DCA Landlord-Tenant Information",
          description:
            "Official state overview of landlord-tenant rules, housing standards, and rental guidance.",
          type: "State",
          url: "https://www.nj.gov/dca/home/landlord-tenant.shtml",
        },
        {
          title: "NJ Housing Resource Center",
          description:
            "Official statewide housing locator and resource center for renters and housing providers.",
          type: "State",
          url: "https://www.nj.gov/njhrc/",
        },
        {
          title: "NJ Bureau of Housing Inspection",
          description:
            "Official information on inspections and compliance for covered housing properties.",
          type: "State",
          url: "https://www.nj.gov/dca/codes/offices/housinginspection.shtml",
        },
      ],
    },
    property_manager: {
      heading: "Property Manager Responsibilities",
      summary:
        "New Jersey property managers should understand licensing, fair housing, maintenance compliance, complaint process, and recordkeeping responsibilities.",
      links: [
        {
          title: "NJ Real Estate Commission",
          description:
            "Official New Jersey Real Estate Commission page for regulatory oversight and compliance information.",
          type: "State Regulator",
          url: "https://www.nj.gov/dobi/remnu.shtml",
        },
        {
          title: "NJ REC Licensing and Education",
          description:
            "Official licensing and education page for New Jersey real estate professionals.",
          type: "State Licensing",
          url: "https://www.nj.gov/dobi/division_rec/licensing/reclic_menu.htm",
        },
        {
          title: "NJ Bureau of Housing Inspection",
          description:
            "Official compliance and inspection resource for covered housing properties.",
          type: "State Compliance",
          url: "https://www.nj.gov/dca/codes/offices/housinginspection.shtml",
        },
      ],
    },
  },
};

export const COUNTY_RIGHTS_LINKS = {
  NJ: {
    sussex: [
      {
        title: "Sussex County Housing Resources",
        description:
          "Official Sussex County housing resources and local service directory links.",
        type: "County",
        url: "https://www.sussex.nj.us/504/Housing",
      },
    ],
  },
};

export function normalizeRightsState(stateCode = "") {
  const normalized = String(stateCode || "").trim().toUpperCase();
  return RIGHTS_DATA[normalized] ? normalized : "NJ";
}
